import { Editable, EditableInput, EditablePreview, Tooltip } from '@chakra-ui/react';
import { useState } from 'react';

import { FormatProperties } from 'models/response/modelOutput.interface';
import formatValue from 'utils/formatValue';
import PlanPermission from 'container/PlanPermission';

interface Properties {
  isGrowthValue: boolean;
  fieldValue: string;
  planPermission: boolean;
  formatProperties: FormatProperties;
  onSubmit: (
    value: string,
    indicatorName: string,
    callback: (value: boolean) => void,
    index: number,
  ) => void;
  setFieldValue: (value: string) => void;
  indicatorName: string;
  index: number;
}

const IndicatorEditableField = ({
  isGrowthValue,
  fieldValue,
  planPermission,
  onSubmit,
  formatProperties,
  setFieldValue,
  indicatorName,
  index,
}: Properties) => {
  const [isEdit, setIsEdit] = useState(false);
  const formattedValue = formatValue(+fieldValue, formatProperties);
  const onFocus = () => {
    setIsEdit(true);
  };

  const onBlur = () => {
    setIsEdit(false);
  };

  const onChange = (nextValue: string) => {
    setFieldValue(nextValue.replace(/(?!-)[^\d.]/g, ''));
  };

  return (
    <Tooltip label={isEdit ? '' : isGrowthValue ? `${fieldValue}%` : formattedValue}>
      <Editable
        value={isEdit ? fieldValue : isGrowthValue ? `${fieldValue}%` : formattedValue}
        onChange={onChange}
        onSubmit={(value: any) => onSubmit(value, indicatorName, () => setIsEdit(false), index)}
        h='7.5'
        maxW='100%'
        cursor={planPermission ? 'not-allowed' : 'pointer'}
        isDisabled={!!planPermission}
        flexGrow='1'
        borderWidth='1'
        borderRadius='xs'
        px={isEdit ? '0' : '1'}
        py='0'
        fontSize='2xs'
        display='flex'
        alignItems='center'
        justifyContent='center'
        textAlign='center'
        whiteSpace={'nowrap'}
        textOverflow={'ellipsis'}
        overflow={'hidden'}
      >
        <EditablePreview w='full' cursor={planPermission ? 'not-allowed' : 'pointer'} />
        <EditableInput
          onFocus={onFocus}
          onBlur={onBlur}
          cursor={planPermission ? 'not-allowed' : 'pointer'}
          onClick={(event: any) => event.stopPropagation()}
          _focusVisible={{
            h: 'full',
            borderWidth: '3',
            borderRadius: 'xs',
            borderColor: 'blue.500',
          }}
        />
      </Editable>
    </Tooltip>
  );
};

export default PlanPermission(IndicatorEditableField);
